unable to read source [project]/node_modules/stripe/src/V2Coercion.ts